import { Box, Text } from '@jfs/ui-new'

export const RenderHeader = ({ title }: any) => {
  return (
    <Box>
      <Text fontSize={18} fontFamily={'JioType-Black'} lineHeight={24} value={title} type="title" />
    </Box>
  )
}
